/**
 * @generated SignedSource<<7e37b908d132baf671d1e2aac7c6453b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeBenefitsNextStatus_tradeFirm$data = {
  readonly rewards: {
    readonly " $fragmentSpreads": FragmentRefs<"rewardsStatusHelper_rewards">;
  } | null;
  readonly " $fragmentType": "TradeBenefitsNextStatus_tradeFirm";
};
export type TradeBenefitsNextStatus_tradeFirm$key = {
  readonly " $data"?: TradeBenefitsNextStatus_tradeFirm$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeBenefitsNextStatus_tradeFirm">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LoyaltyProgram",
    "kind": "LinkedField",
    "name": "programInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "shortCopy",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeBenefitsNextStatus_tradeFirm",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmRewards",
      "kind": "LinkedField",
      "name": "rewards",
      "plural": false,
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "rewardsStatusHelper_rewards",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pointsNeededToLevelUp",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pointsToMaintainStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ParentProgram",
              "kind": "LinkedField",
              "name": "currentProgram",
              "plural": false,
              "selections": (v0/*:: as any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ParentProgram",
              "kind": "LinkedField",
              "name": "nextProgram",
              "plural": false,
              "selections": (v0/*:: as any*/),
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradeFirmType",
  "abstractKey": null
};
})();

(node as any).hash = "6b8d6be20a9e0f3f75cf47be084a0c3b";

export default node;
